import React, { useMemo } from "react";
import { Row, Col, Card, Divider } from "antd";
import { ITripDetails } from "../../../ServiceUsers/Interfaces/ITripDetails";
import styles from "./TripCards.module.scss";
import textStyles from "../../../DashBoard/BookingSummary/BookingSummary.module.scss";
import { Mode } from "../../../../types/ApplicationTypes";

type Props = {
  legNumber: number;
  leg: ITripDetails;
  isWandaPlusTrip: boolean;
  hasPromoCode: boolean;
};

function TripLegCostCard({
  leg,
  legNumber,
  isWandaPlusTrip,
  hasPromoCode,
}: Props) {
  // breakdown cost of each leg without discount
  const legCostWithoutDiscount = useMemo(function() {
    return (
      leg.transportationCost +
      leg?.levelOfServiceCost +
      leg?.vehicleTypeCost
    ).toFixed(2);
  }, []);

  return (
    <Card className={`${styles.costCardsContainer} ${styles.marginDown16}`}>
      <Row className={styles.legCostsAlign} gutter={[0, 4]}>
        <Col span={12} className={textStyles.boldText14}>
          Trip {legNumber}
        </Col>
        <Col span={12} className={textStyles.normalText14}>
          ${legCostWithoutDiscount}
        </Col>
        <Col span={24} />
      </Row>

      <Row
        className={`${textStyles.fadedNormalText14} ${styles.overallCostAlign}`}
        gutter={[0, 4]}
        align="middle"
      >
        <Col span={12}>Transportation</Col>
        <Col span={12}>${leg.transportationCost?.toFixed(2)}</Col>
        <Col span={12}>{leg.levelOfService}</Col>
        <Col span={12}>${leg.levelOfServiceCost?.toFixed(2)}</Col>
        {leg?.modeId === Mode.Paralift && (
          <>
            <Col span={12}>WAV Upgrade</Col>
            <Col span={12}>${leg.vehicleTypeCost?.toFixed(2)}</Col>
          </>
        )}

        <Divider className={styles.solidFadedDivider} />
      </Row>

      {(isWandaPlusTrip || hasPromoCode) && (
        <Row
          className={`${textStyles.fadedNormalText14} ${styles.overallCostAlign}`}
          gutter={[0, 4]}
          align="middle"
        >
          {isWandaPlusTrip && (
            <>
              <Col span={12}>Wanda Plus Discount</Col>
              <Col span={12} className={textStyles.greenNormalText14}>
                {leg.wandaPlanPercentage}% {"\u00A0\u00A0"}
                -${leg.wandaPlusDiscountCost?.toFixed(2)}
              </Col>
            </>
          )}
          {hasPromoCode && (
            <>
              <Col span={12}>Promo Code</Col>
              <Col span={12} className={textStyles.greenNormalText14}>
                {leg.promoCodeDetail.discountType === "Percentage" &&
                  `${leg.promoCodeDetail.discountValue}%`}
                {"\u00A0\u00A0"}
                -${leg.promoCodeDetail.discountedAmount?.toFixed(2)}
              </Col>
            </>
          )}

          <Divider className={styles.solidFadedDivider} />
        </Row>
      )}

      <Row className={styles.overallCostAlign} gutter={[0, 4]}>
        <Col span={12} className={textStyles.normalText16}>
          Charge amount
        </Col>
        <Col span={12} className={textStyles.boldText16}>
          ${leg.tripCost?.toFixed(2)}
        </Col>
      </Row>
    </Card>
  );
}

export default TripLegCostCard;
